export const PAGE_SIZES = [50, 75, 100];
